'use client';

import styled from '@emotion/styled';
import { useTheme } from '@template-project/afrodita-components';
import { ProductCarousel, Slide } from '@/components/molecules/ProductCarousel';
import { ProductCard } from '@/components/molecules/ProductCard';
import { useWeeklyDealsProducts } from '@/lib/hooks';
import { useTranslation } from '@/lib/i18n';
import { useIntl } from '@/lib/intl';
import { LazySection } from '@/components/atoms/LazySection';

const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.background.primary};
`;

function WeeklyDealsContent() {
  const theme = useTheme();
  const { products, loading, error } = useWeeklyDealsProducts();
  const { t } = useTranslation();
  const { localizedPath } = useIntl();

  const hasProducts = !loading && !error && products.length > 0;

  if (!loading && !hasProducts) return null;

  return (
    <Section theme={theme}>
      <ProductCarousel
        title={t('home.weeklyDeals')}
        seeAllPath={localizedPath('/collections/weekly-deals')}
        seeAllLabel={t('home.seeAll')}
        isLoading={loading}
        skeletonCount={4}
        ariaLabel={t('home.weeklyDeals')}
      >
        {products.map((product) => (
          <Slide key={product.id} role="listitem">
            <ProductCard
              id={product.id}
              slug={product.slug}
              name={product.name}
              image={product.image}
              price={product.price}
              compareAtPrice={product.compareAtPrice}
              rating={product.rating}
              reviewCount={product.reviewCount}
            />
          </Slide>
        ))}
      </ProductCarousel>
    </Section>
  );
}

export function WeeklyDeals() {
  return (
    <LazySection minHeight="420px" ariaLabel="Weekly deals section loading">
      <WeeklyDealsContent />
    </LazySection>
  );
}
